import { Button, Stack, Typography } from "@mui/material";
import { ReactNode } from "react";
import { WHITE } from "@/config/mui/colorPalette";
import {
  EventType,
  useClientPortalPaymentPlansMixpanelEvents,
} from "@/hooks/client/useClientPortalPaymentPlansMixpanelEvents";
import useUpdateClientPaymentPlansInterest from "@/hooks/client/useUpdateClientPaymentPlansInterest";

type PaymentPlanSliderCardProps = {
  cardProps: {
    title: ReactNode;
    description: string;
  };
  buttonProps: {
    copy: string;
    onClick?: () => void;
  };
  actionProps: {
    clientId: string;
    medspaId: string;
    eventType: EventType;
    shouldShowToast?: boolean;
  };
};

export type PaymentPlanCardBaseProps = {
  clientId: string;
  medspaId: string;
};

export default function PaymentPlanSliderCard({
  cardProps,
  buttonProps,
  actionProps,
}: PaymentPlanSliderCardProps) {
  const { copy, onClick } = buttonProps;
  const { title, description } = cardProps;
  const { clientId, medspaId, eventType, shouldShowToast } = actionProps;

  const { trackEvent } = useClientPortalPaymentPlansMixpanelEvents(medspaId);

  const { handleMarkAsInterested } = useUpdateClientPaymentPlansInterest(
    clientId,
    shouldShowToast
  );

  return (
    <Stack
      sx={{
        gap: 2,
        textAlign: "center",
        borderRadius: 4,
        alignItems: "center",
        padding: "16px 12px",
        boxSizing: "border-box",
        backgroundColor: WHITE,
        minHeight: "100%",
        height: "100%",
      }}
    >
      {title}
      <Typography variant="paragraphSmall">{description}</Typography>
      <Button
        variant="text"
        sx={{ marginTop: "auto" }}
        onClick={() => {
          onClick?.();
          handleMarkAsInterested();
          trackEvent(eventType);
        }}
      >
        {copy}
      </Button>
    </Stack>
  );
}
